import { render } from "./BalBlankSlate.vue?vue&type=template&id=33ef48c9&ts=true"
import script from "./BalBlankSlate.vue?vue&type=script&lang=ts"
export * from "./BalBlankSlate.vue?vue&type=script&lang=ts"

import "./BalBlankSlate.vue?vue&type=style&index=0&id=33ef48c9&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__